export default "../56fb6e0dbb3d1ef3bd35528d935cac89.png";